import { render, staticRenderFns } from "./MessageRead.vue?vue&type=template&id=6e5eacb0"
import script from "./MessageRead.vue?vue&type=script&lang=js"
export * from "./MessageRead.vue?vue&type=script&lang=js"
import style0 from "./MessageRead.vue?vue&type=style&index=0&id=6e5eacb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports